//@ts-check
//import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";
import { SaveButton } from "./components/SaveButton";

export default class PriceBook{

    static async init(){
        if(!/^\/price-book/.test(location.pathname))
            return
        $('#price-book-tables .bb-preloader-container').removeClass('d-none');
        let entity = $('.data-view')?.attr('data-entity');
        $('#create-btn').off('click').on('click', this.getFormForEvent.bind(this))
        if(entity){
            $('body').off('click', '.stafter-table-body tr td+td').on('click', '.stafter-table-body tr td+td', this.getFormForEvent.bind(this))
            $('.stafter-table-body tr td').removeAttr('onclick')
        }
    }

    static getFormForEvent(ev){
        let elem = $(ev.currentTarget)
        if(elem.prop('tagName').toLowerCase() == 'td')
            elem = $(elem.parents('tr')[0])
        const entity = elem.attr('data-entity')
        const type = elem.attr('data-type')
        let addData={}
        addData[`${entity}_id`] = elem.attr('data-id')
        this.getForm(this.createOrUpdate, entity, type, addData)
    }

    static getForm(callback, entity, type, addParam={}){
        return new Promise(resolve=>{
            $.ajax({
                type: 'GET',
                url: '/price-book/form',
                data: {entity, type, ...addParam},
                success: (response) => {
                    $('#form-container').html(response);
                    $(`#invoice-${entity}-modal`).modal('show');
                    $(`#invoice-${entity}-modal #${type}`).on('click', callback.bind(this))
                    if(entity =='item'){
                        $(`#invoice-${entity}-modal`).on('input', 'input[name="price"], input[name="unit_cost"]',this.maskNumber)
                        $(`#invoice-${entity}-modal`).on('input', 'input[name="quantity"]',this.maskInteger)
                    }
                    resolve(true)
                },
                error:()=>resolve(false)
            });
        })
    }

    static validateItem(data){
        let messages=[]
        if(!data?.name || !data?.name?.length)
            messages.push('The "name" field is not filled in correctly.')
        if(!data?.price || isNaN(Number(data?.price)))
            messages.push('The "price" field is not filled in correctly.')
        if(!data?.price || isNaN(Number(data?.price)))
            messages.push('The "price" field is not filled in correctly.')
        if(!data?.quantity || isNaN(Number(data?.quantity)))
            messages.push('The "quantity" field is not filled in correctly.')
        return messages.length ? {success:false, errors:messages} : {success:true}
    }

    static getDataForInvoice(ev){
        const entity = $(ev.currentTarget).attr('data-entity');
        const formId = `#invoice-${entity}-form`
        let SaveBtn = new SaveButton(formId);
        SaveBtn.startLoading()
        try{
            let data = this.getFormData(formId)
            data.service_type = $(`${formId} select[name=type] option[value="${data.type}"]`).text()
            let result = this.validateItem(data)
            if(!result?.success){
                SaveBtn.stopLoading().then(() => {
                    SaveBtn.showError(result.errors?.join(' '))
                });
                return false
            }else{
                SaveBtn.stopLoading().then(() => {
                    SaveBtn.showSuccess().then(() => {
                        $(`#invoice-${entity}-modal`).modal('hide');
                    });
                });
                return data
            }
        }catch(err){
            SaveBtn.stopLoading().then(() => {
                SaveBtn.showError(err.message)
            });
            return false
        }
        
    }

    static createOrUpdate(ev){
        return new Promise((resolve, reject)=>{
            const entity = $(ev.currentTarget).attr('data-entity');
            const formId = `#invoice-${entity}-form`
            let data = this.getFormData(formId)
            let category_id = $(ev.currentTarget).attr('data-id');
            if (category_id)
                data.category_id = category_id
            let SaveBtn = new SaveButton(formId);
            $.ajax({
                type: 'POST',
                url: `/price-book/${entity}/${ev.currentTarget.id}`,
                data: data,
                beforeSend: () => {
                    SaveBtn.startLoading()
                },
                success: (response) => {
                    if (response?.success) {
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showSuccess().then(() => {
                                $(`#invoice-${entity}-modal`).modal('hide');
                            });
                            if(typeof fetchTableData == 'function')
                                fetchTableData()
                        });
                        data.id = response?.id
                        data.service_type = response?.service_type
                        resolve(data)
                    } else {
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showError(response?.error)
                        });
                        resolve(false)
                    }
                },
                error: () => {
                    SaveBtn.stopLoading().then(() => {
                        SaveBtn.showError();
                    });
                    resolve(false)
                }
            })
        })
    }

    static getFormData(formId){
        let data = {};
        let inputs = $(`${formId} input:not([type=checkbox]), ${formId} textarea, ${formId} select`);
        for (let input of inputs) 
            data[$(input).attr('name')] = $(input).val();
        inputs = $(`${formId} input[type=checkbox]`);
        for (let input of inputs) 
            data[$(input).attr('name')] = $(input).is(':checked') ? 1 : 0;
        return data
    }

    static maskNumber(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9\.]*/.test(value))
            value = value.replace(/[^0-9\.]*/g, '')
        if (value.toString().match(/[.]/g)?.length > 1 || /\.\d{3,}/.test(value))
            value = value.substring(0, value.length - 1)
        $(ev.target).val(value)
    }

    static maskInteger(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9]*/.test(value))
            value = value.replace(/[^0-9]*/g, '')
        $(ev.target).val(value)
    }
}